import { DateRange } from "@mui/x-date-pickers-pro";
import { IExcludedDay } from "src/Pages/Company/Absences/Calendars/Calendars.models";

// Time constants
const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const MILLISECONDS_PER_DAY =
  MILLISECONDS_PER_SECOND *
  SECONDS_PER_MINUTE *
  MINUTES_PER_HOUR *
  HOURS_PER_DAY;

/**
 * Function counting range of days chosen on datepicker.
 * @param {array} dates - two days from which number of days is counted.
 * @param {array} excludedDays - collection of excluded days from yearly calendar.
 * @returns {number} - sum of days in given range.
 */
export default (
  dates: DateRange<Date>,
  billInCalendarDays: boolean,
  excludedDays: IExcludedDay[] = []
) => {
  if (!Array.isArray(dates)) return 0;

  const [startDate, endDate] = dates;

  if (startDate instanceof Date && !(endDate instanceof Date)) return 1;

  if (!(startDate instanceof Date) || !(endDate instanceof Date)) return 0;

  const excludedDates = excludedDays.map((day) => {
    const date = new Date(day.date);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  });

  const excludedCount = billInCalendarDays
    ? 0
    : excludedDates.filter(
        (date) =>
          date >=
            new Date(
              startDate.getFullYear(),
              startDate.getMonth(),
              startDate.getDate()
            ) &&
          date <=
            new Date(
              endDate.getFullYear(),
              endDate.getMonth(),
              endDate.getDate()
            )
      ).length;

  const diffInMs = endDate.getTime() - startDate.getTime();

  // Convert to days and add 1 to include both start and end dates
  return Math.floor(diffInMs / MILLISECONDS_PER_DAY) + 1 - excludedCount;
};
